import { IUser, User } from "..";
import { Doctor } from ".";

interface IAssistance extends IUser {
    doctor: Doctor;
    assistantLead:boolean;
    securePayments: boolean | null;
    paymentPassword: string | null;
}
export class Assistance extends User implements IAssistance {
    doctor: Doctor;
    assistantLead: boolean;
    securePayments: boolean | null;
    paymentPassword: string | null;
    constructor(other?: Partial<IAssistance>) {
        super(other as User);
        this.doctor = other?.doctor || new Doctor();
        this.assistantLead = other?.assistantLead || false;
this.securePayments = other?.securePayments || null;
this.paymentPassword = other?.paymentPassword || null;
    }

    public static fromResponse(res: any): Assistance {
        return new Assistance({ doctor: res.doctor ? Doctor.fromResponse(res.doctor) : new Doctor(), ...User.fromResponse(res),assistantLead:res.assistantLead, securePayments: res.securePayments, paymentPassword: res.paymentPassword });
    }
}